import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import "../Styles/Admin/Customerlogin.css";

export default function CustomerResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" | "error"
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setMessage("Please fill in both fields");
      setMessageType("error");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match");
      setMessageType("error");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${API_BASE_URL}/api/customer/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password: newPassword }),
      });

      const data = await res.json();

      if (data.success) {
        setMessage("Password updated successfully! Redirecting to login...");
        setMessageType("success");
        setTimeout(() => {
          navigate('/admin/customerlogin');
        }, 2000);
      } else {
        setMessage(data.message || "Something went wrong");
        setMessageType("error");
      }
    } catch (err) {
      setMessage("Something went wrong. Please try again.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="customerlogin-container">
      {/* ---------- LEFT dark branding panel ---------- */}
      <div className="customerlogin-left">
        <img
          src="/OS_logo_db.png"
          alt="Outstanding Workplaces Logo"
          className="customerlogin-logo-img"
        />

        <div className="customerlogin-illustration">
          <img
            src="/Customerlogin_img.png"
            alt="Reset Illustration"
          />
        </div>

        <div className="customerlogin-left-bottom">
          <h2>Reset Password</h2>
          <p>Set a new password for your account</p>
        </div>
      </div>

      {/* ---------- RIGHT form panel ---------- */}
      <div className="customerlogin-right">
        <div className="customerlogin-form">
          <h2 className="customerform-heading">Reset Your Password</h2>
          <p className="customerform-subheading">
            Enter a new password for your account
          </p>

          <form onSubmit={handleSubmit}>
            <label className="customerform-label">New Password</label>
            <div className="customerpassword-field">
              <input
                type={showPassword ? "text" : "password"}
                className="customerform-input"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <img
                src={showPassword ? "/Eye_Open.png" : "/Eye_Close.png"}
                alt="toggle password visibility"
                className="customerpassword-eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>

            <label className="customerform-label">Confirm Password</label>
            <div className="customerpassword-field">
              <input
                type={showPassword ? "text" : "password"}
                className="customerform-input"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            {message && (
              <p
                style={{
                  color: messageType === "success" ? "#16a34a" : "#dc2626",
                  fontSize: "14px",
                  marginBottom: "12px",
                  textAlign: "center"
                }}
              >
                {message}
              </p>
            )}

            <button
              type="submit"
              className="customerprimary-btn"
              disabled={loading}
              style={{ opacity: loading ? 0.7 : 1 }}
            >
              {loading ? "Updating..." : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}